import { createContext } from 'react';

import { ModuleKey } from '@/lib/modules';

export type Role = 'admin' | 'teacher' | 'student' | 'employee';

export interface User {
  id: string;
  email: string;
  fullName: string | null;
  role: Role;
  modules: ModuleKey[];
  /** A till account: only the POS pages of its modules, plus its own profile. */
  isPosOperator?: boolean;
}

export interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<void>;
  loginWithGoogle: (idToken: string) => Promise<void>;
  logout: () => Promise<void>;
  isLoading: boolean;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
